import type { ReactNode } from "react";
import { memo } from "react";

import { Box } from "@braintrust/braintrust-ui-components";
import { isPublicBidWithoutUser } from "@js/apps/jobs/apps/bids/helpers";
import { RouterLink } from "@js/components/link";
import type { EmployerBidListBid } from "@js/types/jobs";

import { BidAvatarWithScoreMatch } from "../../bid-avatar-with-score-match";

type BidListItemAvatarProps = {
  bid: EmployerBidListBid;
  jobRoleName: string;
};

export const BidListItemAvatar = memo(
  ({ bid, jobRoleName }: BidListItemAvatarProps) => {
    return (
      <Box sx={{ width: 73, height: 73, minWidth: 73 }}>
        <AvatarWrapper bid={bid}>
          <BidAvatarWithScoreMatch bid={bid} jobRoleName={jobRoleName} />
        </AvatarWrapper>
      </Box>
    );
  },
);

const AvatarWrapper = ({
  bid,
  children,
}: {
  children: ReactNode;
  bid: EmployerBidListBid;
}) => {
  const isPublicBid = isPublicBidWithoutUser(bid);
  if (isPublicBid) {
    return children;
  }

  return (
    <RouterLink to={bid.freelancer.user.profile_url} target="_blank">
      {children}
    </RouterLink>
  );
};
